import { render, staticRenderFns } from "./Efecto-form.vue?vue&type=template&id=67dcfe28"
import script from "./Efecto-form.vue?vue&type=script&lang=js"
export * from "./Efecto-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports